import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default function LocalVideo(handle) {
    gsap.registerPlugin(ScrollTrigger);

    const videos = handle.querySelectorAll('video');
    
    function handleScroll() {
        ScrollTrigger.create({
            trigger: handle,
            start: 'top bottom-=250px',
            once: true,
            onEnter: ({progress, direction, isActive}) => {
                videos.forEach(o => {
                    o.play();
                });
            }
        });
    }

    handleScroll();
}
